import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Calendar, User, ArrowRight, ArrowLeft } from "lucide-react";
import api from "../lib/api";
import { useLang } from "../context/LanguageContext";

export default function Blog() {
  const { t, lang, isRTL } = useLang();
  const Arrow = isRTL ? ArrowLeft : ArrowRight;
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/blog").then((r) => setPosts(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="blog-page">
      <section className="bg-[#0891b2] text-white py-16">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
          <p className="text-[11px] tracking-[0.3em] text-red-200 mb-4 font-semibold">{t.blog.eyebrow}</p>
          <h1 className="font-display text-4xl sm:text-5xl" data-testid="blog-title">{t.blog.title}</h1>
          <p className="text-cyan-100 mt-3 max-w-2xl">{t.blog.subtitle}</p>
        </div>
      </section>

      <section className="py-16">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
          {loading ? (
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
              {[...Array(3)].map((_, i) => <div key={i} className="h-80 bg-slate-100 animate-pulse rounded-lg" />)}
            </div>
          ) : posts.length === 0 ? (
            <p className="text-center text-slate-500 py-16">{t.blog.empty}</p>
          ) : (
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="blog-grid">
              {posts.map((p, i) => (
                <Link key={p.id} to={`/blog/${p.slug}`} data-testid={`blog-card-${i}`}
                      className="bg-white border border-slate-200 hover:border-[#0891b2] hover:shadow-lg transition-all rounded-lg overflow-hidden">
                  <div className="aspect-[16/10] overflow-hidden bg-slate-100">
                    <img src={p.featured_image} alt="" className="w-full h-full object-cover hover:scale-105 transition-transform duration-500" />
                  </div>
                  <div className="p-5">
                    <div className="text-[11px] uppercase tracking-widest text-[#ef4444] mb-2">{p.category}</div>
                    <h3 className="font-display text-lg text-slate-900 mb-2 line-clamp-2">{lang === "ar" ? p.title_ar : p.title_en}</h3>
                    <p className="text-slate-600 text-sm line-clamp-2 mb-3">{lang === "ar" ? p.excerpt_ar : p.excerpt_en}</p>
                    <div className="flex items-center gap-3 text-xs text-slate-500 pt-3 border-t border-slate-100">
                      <span className="flex items-center gap-1"><User className="w-3 h-3" />{p.author}</span>
                      <span className="flex items-center gap-1"><Calendar className="w-3 h-3" />{new Date(p.published_at).toLocaleDateString()}</span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
